import { render, staticRenderFns } from "./SetCard.vue?vue&type=template&id=7ad94826"
import script from "./SetCard.vue?vue&type=script&lang=js"
export * from "./SetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports